/**
 * Issue timeline rules shared by the server (authoritative, inside the write pipeline) and the client (the date
 * picker's disabled days, optimistic checks): the start-date bound (registry issues.start-date AC7) and the timeline's
 * user-facing copy (registry views.timeline-layout*), so both sides say the same thing. Pure and isomorphic.
 */

export const TIMELINE_MSG = {
  /** issues.start-date AC7: a crafted or raced start after the due date. */
  startAfterDue: 'Start date must be on or before the due date',
  /** views.timeline-layout AC11: the timeline chunk failed to load. */
  chunkFailed: 'Couldn’t load the timeline',
  /** drag-dates AC10, keyboard AC13: a rejected move ("Couldn't move ENG-120"). */
  moveFailed: (ident: string): string => `Couldn’t move ${ident}`,
  /** unscheduled-tray AC7. */
  scheduleFailed: (ident: string): string => `Couldn’t schedule ${ident}`,
  /** dependencies AC13. */
  addDependencyFailed: 'Couldn’t add the dependency',
  removeDependencyFailed: 'Couldn’t remove the dependency',
  /** unscheduled-tray AC6. */
  trayEmpty: 'Every issue in this view has dates',
  /** keyboard AC6. */
  dependencyHint: 'Pick the issue this one blocks: Up/Down, Enter; Esc to cancel',
} as const;

/** A `YYYY-MM-DD` date from a wire or row value (a driver may hand back a Date for a date column). */
export function dateOnlyOf(v: unknown): string | null {
  if (v === null || v === undefined) return null;
  if (typeof v === 'string') return /^\d{4}-\d{2}-\d{2}/.test(v) ? v.slice(0, 10) : null;
  if (v instanceof Date && !Number.isNaN(v.getTime())) return v.toISOString().slice(0, 10);
  return null;
}

/** The start-date bound: null when fine, else the message (both set and start > due). */
export function startDateError(startDate: unknown, dueDate: unknown): string | null {
  const s = dateOnlyOf(startDate);
  const d = dateOnlyOf(dueDate);
  return s !== null && d !== null && s > d ? TIMELINE_MSG.startAfterDue : null;
}
